import { SET_NOTIFICATION_SUMMARY } from "../helpers/vuex-constants";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { GET_AUTH_INFORMATION } from "../helpers/vuex-constants";
import { AdvanceSuperFilter } from "../helpers/constant";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      loginUserInfo: GET_AUTH_INFORMATION,
    }),
  },
  methods: {
    ...mapActions({
      setNotificationSummary: SET_NOTIFICATION_SUMMARY,
    }),
    DescriptionAdditionalForm(data, typeId) {
      if (data == undefined || data == "") {
        if (typeId == AdvanceSuperFilter.Accumulation) {
          return "Accumulation";
        } else if (typeId == AdvanceSuperFilter.WithdrawalAccumulation) {
          return "Withdrawal";
        } else if (typeId == AdvanceSuperFilter.WithdrawalPension) {
          return "Withdrawal";
        }else if (typeId == AdvanceSuperFilter.FeeAccumulation) {
          return "Fees";
        } else if (typeId == AdvanceSuperFilter.FeePension) {
          return "Fees";
        }else if (typeId == AdvanceSuperFilter.Contribution) {
          return "Contribution";
        } else if (typeId == AdvanceSuperFilter.Pension) {
          return "Pension";
        } else if (typeId == AdvanceSuperFilter.Pension) {
          return "Withdrawal";
        } else if (typeId == AdvanceSuperFilter.MarketCrash) {
          return "Market Crash";
        } else if (typeId == AdvanceSuperFilter.PensionPayment) {
          return "Pension Payment";
        }
      } else {
        return data;
      }
    },
    createrowModel(data) {
      let NewData = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          let currentRow = data[i];
          NewData[i] = {};
          for (var key of Object.keys(currentRow)) {
            NewData[i][key] = {
              value: currentRow[key],
              IsError: false,
              ErrorText: [],
            };
          }
        }
        return NewData;
      }
    },

    createSaveSuperannuationModel(superannuationUiModel) {
      let superannuationModel = {};
      superannuationModel.clientId = superannuationUiModel.clientId;
      superannuationModel.ownerId = superannuationUiModel.ownerId;
      superannuationModel.superFundId = 0;
      superannuationModel.description = superannuationUiModel.description;
      superannuationModel.contributionAmount =
        superannuationUiModel.contributionAmount;
      superannuationModel.frequencyId = superannuationUiModel.durationTypeId;
      superannuationModel.frankedRate = superannuationUiModel.frankingRate;
      superannuationModel.growthRate = superannuationUiModel.growthRate;
      superannuationModel.incomeRate = superannuationUiModel.incomeRate;
      superannuationModel.superFundGuid = superannuationUiModel.superFundGuid;
      superannuationModel.projectionYear = superannuationUiModel.projectionYear;
      superannuationModel.amount = superannuationUiModel.amount;
      superannuationModel.riskProfileId = superannuationUiModel.riskProfileId;
      superannuationModel.superAddtionalDetails =
        superannuationUiModel.superAddtionalDetails;
      superannuationModel.otherDetail = superannuationUiModel.otherDetail;
      superannuationModel.fundDetails = superannuationUiModel.fundDetails;
      superannuationModel.ownerDetails = superannuationUiModel.ownerDetails;
      superannuationModel.isFromFact = superannuationUiModel.isFromFact;
      superannuationModel.nonSuperData = superannuationUiModel.nonSuperData;
      superannuationModel.parentSuperGuid =
        superannuationUiModel.parentSuperGuid;
      superannuationModel.superAdvanceDetails ==
        superannuationUiModel.superAdvanceDetails;
      superannuationModel.userId = this.loginUserInfo.adviserId;
      return superannuationModel;
    },

    async saveSuperannuationData(apiResponse, data,isUpdate) {
      if (apiResponse && apiResponse.status == 200) {
        this.setNotificationSummary({
          isShow: true,
          variation: "success",
          text: isUpdate == 0 ? `Superannuation instance ${data.description} has been added.`:
          `Superannuation instance ${data.description} has been updated.`
        });
      } else {
        this.setNotificationSummary({
          isShow: true,
          variation: "error",
          text: `Failed to add Superannuation instance ${data.description}.`,
        });
      }
      this.$router.push({ name: "engagement-tool-selection" });
    },

    //   let superannuationModel = {};
    //   superannuationModel.clientId = selectedSuperannuation.clientId;
    //   investmentModel.ownerId = selectedSuperannuation.ownerId;
    //   investmentModel.investmentID = 0;
    //   investmentModel.description = selectedSuperannuation.description;
    //   investmentModel.contributionAmount = investemntUiModel.contributionAmount;
    //   investmentModel.frequencyId = investemntUiModel.durationTypeId;
    //   investmentModel.ownerEntityTypeId = selectedInvestment.ownerEntityType;
    //   investmentModel.frankedRate = investemntUiModel.frankingRate;
    //   investmentModel.growthRate = investemntUiModel.growthRate;
    //   investmentModel.incomeRate = investemntUiModel.incomeRate;
    //   investmentModel.platformid = investemntUiModel.platformId;

    //   investmentModel.investmentGuid = selectedInvestment.investmentGuid;
    //   investmentModel.parentInvestmentGuid =
    //     selectedInvestment.parentInvestmentGuid;
    //   investmentModel.projectionYear = selectedInvestment.projectionYear;
    //   investmentModel.investmentAmount = investemntUiModel.amount;
    //   investmentModel.investmentID = 0;
    //   investmentModel.isDRP = investemntUiModel.isDRP;
    //   investmentModel.riskProfileId = investemntUiModel.riskProfileId;
    //   investmentModel.investmentClassID = selectedInvestment.investmentClassID;
    //   investmentModel.isRenewAuto = selectedInvestment.isRenewAuto;
    //   investmentModel.maturityDate = selectedInvestment.maturityDate;
    //   investmentModel.advancedetails = selectedInvestment.advancedetails;
    //   investmentModel.isExisting = selectedInvestment.isExisting;

    //   investmentModel.userId = this.loginUserInfo.adviserId;
    //   return investmentModel;
    // },
  },
};
